import { ReactElement, useEffect, useRef, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import Home from '@/views/home';
import { useLocation, useMatch, useNavigate, Navigate } from 'react-router-dom';
import routers from '@/routers';
import TransitionWrapper from '@/components/TransactionWrapper';
import Headers from '@/views/header/Headers';
import SealIcon from '@/components/SealIcon';
import { getHomeSectionIndexByPath, getHomeSectionPath, isHomeSectionPath } from '@/services/menu';

const AnimationRoute = (): ReactElement => {
    const pageScrollRef = useRef<any>(null);
    const menuScrollRef = useRef<any>(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [index, setIndex] = useState(() => getHomeSectionIndexByPath(window.location.pathname) || 0);

    useEffect(() => {
        pageScrollRef.current ? pageScrollRef.current.gotoPage(index) : void 0;
    }, [index]);

    useEffect(() => {
        const nextIndex = getHomeSectionIndexByPath(location.pathname);
        if (nextIndex !== undefined && nextIndex !== index) {
            setIndex(nextIndex);
        }
    }, [index, location.pathname]);

    const onChangeMenu = (__index: number) => setIndex(__index);
    const onChangeScroll = (__index: number) => {
        menuScrollRef.current?.gotoPage(__index);
        const nextPath = getHomeSectionPath(__index);
        if (location.pathname !== nextPath) {
            navigate(nextPath, { replace: true });
        }
    };

    // v6：用 useMatch 判断是否命中 "/"（end:true 等价 v5 的 exact）
    const homeMatch = useMatch({ path: '/', end: true });
    const homeSectionMatch = useMatch({ path: '/home/:section?', end: true });
    const isHomeRoute = !!homeMatch || !!homeSectionMatch || isHomeSectionPath(location.pathname);

    return (
        <div>
            <Headers onChangeMenu={onChangeMenu} ref={menuScrollRef} />
            {isHomeRoute ? <Home initialPageIndex={index} onChangeScroll={onChangeScroll} ref={pageScrollRef} /> : null}
            <TransitionGroup component={null}>
                {/* 其他路由块 */}
                {routers
                    .filter((route: any) => route.path !== '/home/:type?')
                    .map((route: any) => (
                        <RouteBlock key={route.path} route={route} />
                    ))}
            </TransitionGroup>

            {/* 非路由元素，照旧渲染 */}
            <SealIcon />
        </div>
    );
};

function RouteBlock({ route }: { route: any }) {
    // v6：不再使用 <Route children>，改为在组件里用 useMatch 判定
    const match = useMatch({ path: route.path, end: true });

    return (
        <TransitionWrapper isIn={!!match} key={route.path}>
            {match ? route.redirect !== undefined ? <Navigate to={route.redirect} replace /> : <route.component {...(route.props || {})} routes={route.routes} /> : null}
        </TransitionWrapper>
    );
}

export default AnimationRoute;
